<div class="cartouche-filter-bar">
  <input type="text" [(ngModel)]="filter" (ngModelChange)="applyFilter()" placeholder="Filtrer par nom de cartouche..." style="margin-bottom:1rem;width:250px;">
  <select
    [(ngModel)]="chimieFilter"
    (ngModelChange)="applyFilter()"
    style="margin-bottom:1rem;margin-left:0.5rem;width:250px;"
  >
    <option [ngValue]="null">Toutes les chimies</option>
    @for (chimie of chimies; track chimie.id) {
      <option [ngValue]="chimie.id">{{ chimie.nom }}</option>
    }
  </select>
</div>
@if (!loading && paged.length) {
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th>Nom</th>
          <th>Lot</th>
          <th>Chimie</th>
          <th>Utilisée ou réservée</th>
          <th>Inutilisable</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (cartouche of paged; track cartouche.id) {
          <tr>
            <td>{{ cartouche.id }}</td>
            <td>{{ cartouche.nom }}</td>
            <td>{{ getLotNom(cartouche.lot_cartouche_id) }}</td>
            <td>{{ getChimieNom(cartouche.chimie_id) }}</td>
            <td>{{ cartouche.utilise ? 'Oui' : 'Non' }}</td>
            <td>{{ cartouche.inutilisable ? 'Oui' : 'Non' }}</td>
            <td>
              <button type="button" (click)="goToEdit(cartouche.id)">Modifier</button>
              <button type="button" class="danger" [disabled]="deletingId === cartouche.id" (click)="deleteCartouche(cartouche.id)">
                {{ deletingId === cartouche.id ? 'Suppression...' : 'Supprimer' }}
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (pageCount() > 1) {
    <div class="pagination">
      <button (click)="page = 1" [disabled]="page === 1">«</button>
      <button (click)="page = page - 1" [disabled]="page === 1">‹</button>
      <span>Page {{ page }} / {{ pageCount() }}</span>
      <button (click)="page = page + 1" [disabled]="page === pageCount()">›</button>
      <button (click)="page = pageCount()" [disabled]="page === pageCount()">»</button>
    </div>
  }
} @else if (!loading) {
  <p>Aucune cartouche disponible.</p>
}
@if (pageCount() > 1) {
	<div class="pagination">
		<button (click)="page = 1" [disabled]="page === 1">«</button>
		<button (click)="page = page - 1" [disabled]="page === 1">‹</button>
		<span>Page {{ page }} / {{ pageCount() }}</span>
		<button (click)="page = page + 1" [disabled]="page === pageCount()">›</button>
    <button (click)="page = pageCount()" [disabled]="page === pageCount()">»</button>
	</div>
}
